"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = priceReducer;
var _assign = _interopRequireDefault(require("lodash/assign"));
var _actionTypes = require("../actions/actionTypes");
var initialState = {
  pricing: {
    price: 0.0,
    strikeThroughPrice: {
      hasStrikeThroughPricing: false,
      price: 0.0,
      percentage: 0.0,
      originalPrice: 0.0,
      priceSavings: 0.0,
      message: ''
    },
    choiceDeltas: []
  }
};
function buildPricingModel(price, strikeThroughPrice, choiceDeltas) {
  return {
    pricing: {
      price: price,
      strikeThroughPrice: strikeThroughPrice,
      choiceDeltas: choiceDeltas
    }
  };
}
function priceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _actionTypes.PRICE_CHANGED_SUCCESS:
      return (0, _assign["default"])({}, state, buildPricingModel(action.asConfigured, action.strikeThroughPriceModel, action.choiceDeltas));
    case _actionTypes.PRICE_CHANGED_FAILURE:
      return (0, _assign["default"])({}, state, buildPricingModel(null, null, null));
    default:
      return state;
  }
}
//# sourceMappingURL=priceReducer.js.map